<template>
  <div class="container-fluid">
    <!-- page header -->

    <h2 class="mt-5 mb-3">
      {{ this.routeIsArchive ? "Participants Archivés" : "Participants" }}
    </h2>
    <b-btn @click="moveToNextRoute" variant="outline-info" pill class="mb-4">
      {{
        routeIsArchive
          ? "Retour aux participants actifs"
          : "Voir les participants archivés"
      }}</b-btn
    >

    <!-- filters -->
    <div
      class="bg-light py-3 container-fluid"
      :class="{ disabledfilters: disabledFilters }"
    >
      <b-form inline class="justify-content-between mb-2">
        <div class="mb-2">
          <label class="mr-3 d-inline" for="inline-form-group">Groupe</label>
          <b-form-select
            v-model="groupSelected"
            :options="groups.data.data"
            class="mr-3"
            id="select-horizontal"
            text-field="name"
            value-field="id"
          >
            <template v-slot:first>
              <b-form-select-option :value="null">
                Choisir un groupe
              </b-form-select-option>
            </template>
          </b-form-select>
          <label class="mr-3 d-inline" for="inline-form-input-name"
            >Délibérations</label
          >
          <b-form-select
            v-model="dlibrSelected"
            @change="onChange({ deliberation: $event })"
            :options="teacherDlibr.data.data"
            class="mr-3"
            id="select-horizontal"
            text-field="title"
            value-field="id"
            :disabled="
              !teacherDlibr.data.data.length ||
                teacherDlibr.status == 'fetching'
            "
          >
            <template v-slot:first>
              <b-form-select-option :value="null">
                Choisir une délibération
              </b-form-select-option>
            </template>
          </b-form-select>
        </div>
        <div class="mb-2">
          <label class="sr-only" for="inline-form-input-name">search</label>
          <b-input
            id="inline-form-input-name"
            class="mb-2 mr-sm-2 mb-sm-0"
            placeholder="Recherche"
            v-model="nameFilter"
            @change="onChange({ search: $event })"
          ></b-input>
          <b-btn :disabled="!nameFilter" pill variant="primary"
            >Rechercher</b-btn
          >
        </div>
      </b-form>
      <div
        :hidden="
          !teacherStudnets.data.data.length ||
            this.teacherStudnets.status != 'success'
        "
      >
        <b-form inline class="justify-content-md-between">
          <div class="mb-2">
            <b-row>
              <b-col cols="12" sm="auto" class="mb-2 mb-sm-0">
                <b-btn
                  variant="info"
                  pill
                  @click="archiveConfirm('all')"
                  :disabled="spinnerArchive.all"
                >
                  {{ routeIsArchive ? "Déarchiver tous" : "Tout archiver" }}
                  <b-spinner
                    class="ml-2"
                    small
                    v-if="spinnerArchive.all"
                  ></b-spinner>
                </b-btn>
              </b-col>
              <b-col cols="12" sm="auto">
                <b-btn
                  :variant="Boolean(rowSelected.length) ? 'info' : 'secondary'"
                  pill
                  :disabled="
                    !Boolean(rowSelected.length) || spinnerArchive.select
                  "
                  @click="onArchive"
                >
                  {{
                    routeIsArchive
                      ? "Déarchiver la sélection"
                      : "Archiver la sélection"
                  }}
                  <b-spinner
                    class="ml-2"
                    small
                    v-if="spinnerArchive.select"
                  ></b-spinner>
                </b-btn>
              </b-col>
            </b-row>
          </div>
          <div class="mb-2">
            <b-row>
              <b-col cols="12" sm="auto" class="mb-2 mb-sm-0">
                <b-btn
                  variant="info"
                  pill
                  @click="onExportCvs('all')"
                  :disabled="spinnerExport.all"
                  >Tout exporter en XLS
                  <b-spinner
                    class="ml-2"
                    small
                    v-if="spinnerExport.all"
                  ></b-spinner>
                </b-btn>
              </b-col>
              <b-col cols="12" sm="auto">
                <b-btn
                  :variant="Boolean(rowSelected.length) ? 'info' : 'secondary'"
                  pill
                  :disabled="
                    !Boolean(rowSelected.length) || spinnerExport.select
                  "
                  @click="onExportCvs"
                  >Exporter la sélection en XLS
                  <b-spinner
                    class="ml-2"
                    small
                    v-if="spinnerExport.select"
                  ></b-spinner>
                </b-btn>
              </b-col>
            </b-row>
          </div>
        </b-form>
      </div>
    </div>
    <b-table
      ref="selectableTable"
      selectable
      select-mode="multi"
      selected-variant="none"
      class="mb-5 table2"
      show-empty
      stacked="md"
      :items="teacherStudnets.data.data"
      outlined
      bordered
      :busy="isBusy"
      empty-text="Faites une recherche pour trouver des résultats"
      :fields="fields.student"
      @row-selected="onRowSelected"
      no-select-on-click
      :tbody-tr-class="rowClass"
    >
      <template v-slot:table-busy>
        <div class="text-center text-primary my-2">
          <b-spinner class="align-middle"></b-spinner>
          <p>Actualisation en cours...</p>
        </div>
      </template>

      <template v-slot:cell(check)="row">
        <template v-if="row.rowSelected">
          <b-btn variant="none" @click="unselectRow(row.index)">
            <b-icon icon="check-square"></b-icon>
          </b-btn>
        </template>
        <template v-else>
          <b-btn variant="none" @click="selectRow(row.index)">
            <b-icon icon="square"></b-icon>
          </b-btn>
        </template>
      </template>
      <template v-slot:cell(student)="row">
        <b-link
          :to="{
            name: 'teachers.participant.profile',
            params: {
              id: row.item.id,
              group: row.item.group ? row.item.group.id : null
            }
          }"
        >
          <span v-html="row.value"></span>
        </b-link>
      </template>
      <template v-slot:cell(group)="row">
        <span v-html="row.value"></span>
      </template>
      <template v-slot:cell(deliberations)="row">
        <template v-if="row.value.length == 1">
          {{ row.value[0].title }}
        </template>
        <template v-else>
          <ul class="pl-3 m-0">
            <li v-for="dlibr in row.value" :key="dlibr.id">
              {{ dlibr.title }}
            </li>
          </ul>
        </template>
      </template>
    </b-table>

    <!-- User Interface controls -->
    <b-row>
      <b-col cols="4" class="my-1">
        <b-pagination
          pills
          v-model="table.currentPage"
          :total-rows="table.totalRows"
          :per-page="table.perPage"
          class="my-0"
          @change="pageChange"
        ></b-pagination>
      </b-col>
    </b-row>
  </div>
</template>

<script>
/**
 * @file       Teachers participants component.
 * @author     Appwapp <info@appwapp.com>
 * @copyright  © Centre collégial de développement de matériel didactique, Collège de Maisonneuve, 2021
 * @license    https://www.ccdmd.qc.ca
 * @version    1.0
 */

import store from "@/store";
import { mapState } from "vuex";

/**
 * Export the component.
 * 
 * @type  {Object}
 */
export default {
  name: "groupParticipantList",

  /**
   * Data used in the component.
   *
   * @return  {Object}
   */
  data() {
    return {
      spinnerArchive: { all: false, select: false },
      spinnerExport: { all: false, select: false },
      disabledFilters: false,
      configurationMsg: {
        title: "Veuillez confirmer",
        okTitle: "Accepter",
        cancelTitle: "Annuler",
        footerClass: "p-2",
        hideHeaderClose: false,
        centered: true
      },
      rowSelected: [],
      nameFilter: null,
      dlibrSelected: null,
      fields: {
        student: [
          {
            key: "check",
            label: "Sélection",
            class: "text-center align-middle"
          },
          {
            key: "student",
            label: "Nom des participants",
            sortable: true,
            sortDirection: "desc",
            formatter: (value, key, item) => {
              let statusAdmin = this.statusOptionAdmin[item.status];
              let statusText = "";
              statusText = statusAdmin ? `( ${statusAdmin.text} )` : "";
              return `${item.name} ${item.last_name} <small><i class='text-muted'>${statusText}</i></small>`;
            },
            class: "align-middle"
          },
          {
            key: "nickname",
            label: "Pseudonyme",
            sortable: true,
            sortDirection: "desc",
            class: "align-middle"
          },
          {
            key: "group",
            label: "Groupe",
            sortable: true,
            sortDirection: "desc",
            formatter: (value, key, item) => {
              let statusGroup = this.statusOptionGroup[
                item?.group?.pivot?.status
              ];
              let statusText = "";
              statusText = statusGroup ? `( ${statusGroup.text} )` : "";
              return `${item.group.name}  <small><i class='text-muted'>${statusText}</i></small> `;
            },
            class: "align-middle"
          },
          {
            key: "deliberations",
            label: "Nombre de délibération(s) jointe(s)",
            sortable: true,
            sortDirection: "desc",
            formatter: (value, key, item) => {
              return item.group.deliberations;
            },
            class: "align-middle"
          },
          {
            key: "general_grade",
            label: "Moyenne",
            sortable: true,
            sortDirection: "desc",
            class: "text-right align-middle",
            formatter: (value, key, item) => {
              return `${parseInt(item.general_grade)} %`;
            }
          }
        ]
      },
      statusOptionAdmin: {
        4: { text: "Archivé", value: 4 },
        5: { text: "Suspendu", value: 5 },
        6: { text: "supprimer", value: 6 }
      },
      statusOptionGroup: {
        2: { text: "supprimer", value: 2 },
        3: { text: "Suspendu", value: 3 },
        4: { text: "Archivé", value: 4 }
      }
    };
  },

  /**
   * Computed properties.
   * 
   * @type  {Object}
   */
  computed: {
    ...mapState({
      teacherStudnets: state => state.groups.teacherStudnets,
      groups: state => state.groups.teacherGroups,
      teacherDlibr: state => state.deliberations.teacherDlibr,
      profile: state =>
        state.auth.profile.data ? state.auth.profile.data.data.find(u => u) : {}
    }),

    /**
     * Pager table.
     *
     * @return     {Object}
     */
    table() {
      return {
        totalRows: this.teacherStudnets.data.total,
        currentPage: this.teacherStudnets.data.current_page,
        perPage: this.teacherStudnets.data.per_page
      };
    },

    /**
     * Check if the status of teacher participants is busy.
     *
     * @return     {bool}  Busy or not.
     */
    isBusy() {
      return this.teacherStudnets.status === "fetching";
    },

    /**
     * Selected group of participants.
     *
     * @return     {Object}  Participant
     */
    groupSelected: {
      get() {
        return this.teacherStudnets.filters.group;
      },
      set(value) {
        if (value) {
          this.$store.commit("deliberations/setTeacherDlibrFilters", {
            reset: true,
            fields: { teacher: this.profile.id, group: value }
          });
          this.$store.dispatch("deliberations/getTeacherDlibr");
        } else {
          this.dlibrSelected = null;
          this.$store.commit("deliberations/setTeacherDlibr", { data: [] });
        }
        this.$store.commit("groups/setTeacherStudnetsFilters", {
          reset: true,
          fields: { group: value }
        });
        this.$store.dispatch("groups/getTeacherStudnets");
      }
    },

    /**
     * Check if the route is "archive".
     *
     * @return     {bool}  Archived or not.
     */
    routeIsArchive() {
      return this.$route.name == "teachers.participants.archive";
    }
  },

  /**
   * Before route change.
   * 
   * @param  {string}   to     Destination
   * @param  {string}   from   (Unused)
   * @param  {Object}   next   The action
   */
  beforeRouteEnter(to, from, next) {
    const status = {};
    if (to.name == "teachers.participants.archive") {
      status.status = 4;
      status.status_user_group = 4;
    }
    store.commit("deliberations/setTeacherDlibr", { data: [] });
    store.commit("groups/setTeacherStudnetsFilters", {
      reset: true,
      fields: {
        ...status
      }
    });
    store.commit("groups/setTeacherGroupsFilters", {
      reset: true,
      fields: {
        teacher: parseInt(to.params.id),
        resourcesPerPage: 50
      }
    });
    Promise.all([
      store.dispatch("groups/getTeacherStudnets"),
      store.dispatch("groups/getTeacherGroups")
    ]).then(() => {
      next();
    });
  },

  /**
   * Methods.
   * 
   * @type  {Object}
   */
  methods: {
    /**
    * Teachers participants list.
    */
    moveToNextRoute() {
      if (this.routeIsArchive) {
        this.$router.push({
          name: "teachers.participants",
          params: { id: this.profile.id }
        });
      } else {
        this.$router.push({
          name: "teachers.participants.archive",
          params: { id: this.profile.id }
        });
      }
    },

    /**
     * Format type status.
     *
     * @param      {int}  status     The status
     *
     * @return     {String}          The status display text
     */
    formatTypeStatus(status) {
      switch (status) {
        case 5:
          return "(suspendu)";
        case 6:
          return "(Supprimé)";
        default:
          return "";
      }
    },

    /**
     * Format type group status.
     *
     * @param      {int}  status     The status
     *
     * @return     {String}          The status display text
     */
    formatTypeStatusGroup(status) {
      switch (status) {
        case 3:
          return "(suspendu)";
        default:
          return "";
      }
    },

    /**
     * Row class.
     *
     * @param       {int}     item     The item
     * @param       {int}     type     The type
     *
     * @return      {string}  index     The row index
     */
    rowClass(item, type) {
      if (!item || type !== "row") return;
      if (item.status === 5 || item.status === 6) return "text-muted";
    },

    /**
     * Select row.
     *
     * @param      {int}  index     The row index
     */
    selectRow(index) {
      this.$refs.selectableTable.selectRow(index);
    },

    /**
     * Unselect row.
     *
     * @param      {int}  index     The row index
     */
    unselectRow(index) {
      this.$refs.selectableTable.unselectRow(index);
    },

    /**
     * Clear selected rows.
     */
    clearSelected() {
      this.$refs.selectableTable.clearSelected();
    },

    /**
     * Row selected.
     */
    onRowSelected(items) {
      this.rowSelected = items;
    },

    /**
     * Change teachers participants page.
     *
     * @param      {int}  page     The page number
     */
    pageChange(page) {
      this.$store.commit("groups/setTeacherStudnetsFilters", {
        fields: { page }
      });
      this.$store.dispatch("groups/getTeacherStudnets");
    },

    /**
     * Change teachers participants.
     *
     * @param      {Object}  row     The select
     */
    onChange(select) {
      this.$store.commit("groups/setTeacherStudnetsFilters", {
        fields: { ...select }
      });
      this.$store.dispatch("groups/getTeacherStudnets");
    },

    /**
     * Archive confirm message.
     *
     * @param      {string}  option     The option
     */
    archiveConfirm(option) {
      this.rowSelected = [];
      this.clearSelected();
      this.$bvModal
        .msgBoxConfirm(
          this.routeIsArchive
            ? "Confirmez que vous voulez vraiment tout désarchiver."
            : "Veuillez confirmer que vous voulez vraiment tout archiver.",
          this.configurationMsg
        )
        .then(value => {
          if (value) this.onArchive(option);
        })
        .catch();
    },

    /**
     * Archive confirmed.
     *
     * @param      {string}  option     The option
     */
    onArchive(option) {
      const payload = {};
      if (option == "all") {
        payload.all = true;
        this.spinnerArchive.all = true;
        if (this.routeIsArchive) {
          payload.status_user_group = 4;
          payload.status = 1;
        }
        if (this.groupSelected) {
          payload.group = this.groupSelected;
        }
        if (this.dlibrSelected) {
          payload.deliberation = this.dlibrSelected;
        }
      } else {
        this.spinnerArchive.select = true;
        if (this.routeIsArchive) {
          payload.status = 1;
        }
        payload.to_change_status = this.rowSelected.map(selected => {
          return {
            user: selected.id,
            group: selected.group.id
          };
        });
      }
      store.dispatch("groups/putStudentsArchived", payload).then(() => {
        this.spinnerArchive.all = false;
        this.spinnerArchive.select = false;
        this.$root.$bvToast.toast(
          `Les participants ont été archivés avec succès.`,
          {
            title: "Succès"
          }
        );
      });
    },

    /**
     * Export CSV.
     *
     * @param      {string}  option     The option
     */
    onExportCvs(option) {
      const payload = {};
      payload.name = "participants";
      if (this.groupSelected) {
        payload.group = this.groupSelected;
      }
      if (this.dlibrSelected) {
        payload.deliberation = this.dlibrSelected;
      }
      if (option == "all") {
        this.spinnerExport.all = true;
      } else {
        this.spinnerExport.select = true;
        payload.users = this.rowSelected.map(selected => {
          return {
            id: selected.group.pivot.user,
            group: selected.group.pivot.group
          };
        });
      }
      this.$store
        .dispatch("files/getUserExportXls", payload)
        .then(() => {
          this.spinnerExport.all = false;
          this.spinnerExport.select = false;
          this.$root.$bvToast.toast(
            `Le document a été téléchargé avec succès.`,
            {
              title: "Succès"
            }
          );
        })
        .catch(() => {
          this.spinnerExport.all = false;
          this.spinnerExport.select = false;
          this.$root.$bvToast.toast("Le téléchargement du document a échoué.", {
            title: "Erreur",
            variant: "danger"
          });
        });
    }
  }
};
</script>

<style lang="scss" scoped>
.disabledfilters {
  pointer-events: none;
  opacity: 0.7;
}

.text-muted {
  color: #6c757d !important;
  a {
    color: #6c757d !important;
  }
}
</style>
